<template minapp="mpx" xlang="wxml">
 <es-layout
    custom-class="custom-class"
    navbarTitle="身份核验"
    layout="{{['header', 'footer']}}"
    navbarStyle="{{navbarStyle}}"
    esMainStyle="{{esMainStyle}}"
    leftArrow="{{true}}"
  >
 <view class="verify-main">
   <image mode="widthFix"
   wx:style="width: 100%; box-sizing: border-box;
    padding: 10px 17px;"
   src="https://img-hxy021.didistatic.com/static/starimg/img/v2R6EbgP101683717815365.png"/>
   <view class="verify-indentity-card">
    为完善铁路实名购票，铁路局自2014年3月1日起对12306本人和其他乘客进行身份信息核验
   </view>
   <order-title-card title="身份核验未通过？" customStyle="{{customStyle}}">
    <view class="verify-tips verify-tips__title">
      核验方法
    </view>
    <view class="verify-tips verify-tips__subtitle">
      1.请修改乘客身份信息与证件原件完全一致后，重新添加乘车人
    </view>
    <view class="verify-tips verify-tips__subtitle">
      2.如还未通过，请持该 12306 账号注册人的证件原件及未核验通过乘客的购票证件原件至车站窗口办理核验
    </view>
  
   </order-title-card>
  </view>

 </es-layout>
 <es-toast id='es-toast' />
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { isFastDoubleClick } from '@/utils/double-click'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { setClipboardData } from '@didi/es-mpx-shared'

  createPage({
    onShow() {},
    data() {
      return {
        navbarStyle: {
          background: '#1473FF',
          'font-size': '18px',
          'font-weight': 600,
          color: '#ffffff',
          'font-family': 'PingFangSC-Semibold'
        },
        esMainStyle: {
          background: '#F0F1F4'
        },
        customStyle: {
          margin: '10px 0 0',
          fontFamily: 'PingFangSC-Medium'
        }
      }
    },
    computed: {
      ...store.mapState({})
    },

    methods: {
      ...store.mapMutations({})
    }
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .verify-main
    padding 0 12px
    background-repeat no-repeat
    background-size 100vw
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/GhAT99OZEA1683711738840.png')
    background linear-gradient(to bottom, #1473FF, #F0F1F4)
  .verify-indentity-card
    font-size 12px
    margin-top -10px
    background #FFF4EE
    display flex
    padding 12px 16px
    color #FF7D41
    border-radius 8px
    font-family PingFangSC-Regular
  .verify-tips
    font-size 12px
    color #333333
    font-family PingFangSC-Regular
    &__title
      font-weight bold
      color #1473FF
      margin-bottom 6px
      font-family PingFangSC-Semibold
    &__subtitle
      font-size 14px
      font-weight 400
      white-space pre-line
      margin-top 8px
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'es-toast': '@didi/es-mpx-ui/lib/toast',
      'order-title-card': '@/components/order-title-card'
    }
  }
</script>